import { render, staticRenderFns } from "./line-x-stack.vue?vue&type=template&id=22b64589&"
import script from "./line-x-stack.vue?vue&type=script&lang=js&"
export * from "./line-x-stack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports